define('views/lookbookpage/index',[],function() {
	'use strict';

	window.assets = window.assets || {};

	require(['classes/images'], function(images) {
		window.assets.images = images;
		window.assets.images.initiate(function() {
			console.log('images initiated the old way');
		});
	});

	require(['classes/lazyload'], function(LazyLoad) {
	    window.assets.lazyload = new LazyLoad().initiate();
	});

	require(['classes/socialbutton'], function(SocialButton) {
		var socialButtons = document.querySelectorAll('#share-buttons a'),
			i;
		for (i = 0; i < socialButtons.length; ++i) {
			new SocialButton({
				element: socialButtons[i],
				type: socialButtons[i].getAttribute('data-share-type')
			}).initiate();
		}
	});

	require(['classes/look'], function(look) {
		window.assets.look = look;
		window.assets.look.initiate(function() {
			console.log('look initiated the old way');
		});
	});

	require(['classes/lookpage'], function(lookpage) {
		window.assets.lookpage = lookpage;
		window.assets.lookpage.initiate(function() {
			console.log('lookpage initiated the old way');
		});
	});

	require(['classes/productDetails'], function(productDetails) {
		window.assets.productDetails = productDetails;
		window.assets.productDetails.initiate(function() {
			console.log('productDetails initiated the old way');
		});
	});

	require(['classes/backbutton'], function(backButton) {
		window.assets.backButton = backButton;
		window.assets.backButton.initiate(function() {
			console.log('backButton initiated the old way');
		});
	});

	require(['classes/modal'], function(modal) {
		window.assets.modal = modal;
		window.assets.modal.initiate(function() {
			console.log('modal initiated the old way');
		});
	});

	require(['classes/packshot'], function(packshot) {
		window.assets.packshot = packshot;
		window.assets.packshot.initiate(function() {
			console.log('packshot initiated the old way');
		});
	});

	require(['classes/crossimages'], function(crossImages) {
		window.assets.crossImages = crossImages;
		window.assets.crossImages.initiate(function() {
			console.log('crossImages initiated the old way');
		});
	});

	/*require(['classes/swipeband'], function(swipeBand) {
		window.assets.swipeBand = swipeBand;
		window.assets.swipeBand.initiate(function() {
			console.log('swipeBand initiated the old way');
		});
	});*/

	require(['classes/lookcarousel'], function(LookCarousel) {
		var lookCarousels = document.querySelectorAll('.look-swiper'),
			i;
		for (i = 0; i < lookCarousels.length; ++i) {
			new LookCarousel({
				element: lookCarousels[i],
				lazyLoad: window.assets.lazyload
			}).initiate();
		}
	});
});
